function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "@font-face{font-family:iconfont;src:url(iconfont.eot?t=1587278484908);src:url(iconfont.eot?t=1587278484908#iefix) format(\"embedded-opentype\"),url(\"data:application/x-font-woff2;charset=utf-8;base64,d09GMgABAAAAAAQUAAsAAAAACGQAAAPIAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHEIGVgCDHAqEIINWATYCJAMQCwoABCAFhG0HSBtIB8gekiSBEAEFAABQMEI8fK2V7/f07PURKkSF8oLlCRWzjowi9ih0KkZxeTZi/68u+zM1AVxZIbKrB3w9FbAnYE+WPkW47VH2OTkJTP7HvaqZ/gM23108LnNsy4VyAQyNrQHaq3OAFbAVxi6HM6/Co+tmAm1GbSHYmZJVBMYysigQF6XiejBOqeUaQiiyRsnOLB5AraR7wmvAff/v4z+shDFJXSErd51OboK4X/YfxpBuRQfHXBRwxjNC3EeFZSATZ0vNx6EwvAxp08eLbABFkRhrwPPD2MoK5u5FXOi/PCpJEA0kuwOs4UjFL3ubHUs8QSmBZAy4N5CdQekd/Qh8k+TD44wMZdzcfNjD0Cw6SUHccdw3Zl9U4tBM6RyKi/bQOOzlnUqLT5/tdSwp3d9b+kBfdK+v+P546cP+snv6kgf9gWA8+Rl9nebo7szYFKSOJ1O6aQcL4dNpftYJWTyf7Z3pvHevyHSsaLyZWf5yP9ni4sNSA7O30rPWmT54UHT8Ln/bQzJxxtPAKr85ZWoeB/lZN3RoIGZzRkIqGLUUEGfhwYI5qc0BlwNHj5HgiOsq1xE/cHTUZdQGM/MMKjwAhNFjRx/g2rVzt57bpdfv4vS7d/Hcbp7fzZ18z7VlMaSdy0K49ixBW7gKwnbfqk+0SvJKskqs+5XojfxV120V6JVo1V33Kgn9SMAnZFkgPinK+mw/s+GQQ5ANZO4jv6deFzUJsqx9/aY3Tvs9Q1lM0/zyuoLcgnVhV+ryja1XWxsnOE/C5jWbSuQoqvCWOTjaV56wlts7OlSsqrCwkyfIvCtEjqjSBjQAzRAt1oHmaAaFWVHoCpL/7lk+cV+sa62i/pf26637ecZuj+9qEkE/zj/jtOb8XE7LimzwiCZnjW+zzczsIGPelVIb1fFL4/R5MYZ1EMTGUCQOQNJiBCrFNDrjl6HWbg0aii3QZknq/nb9WEjkViwaRBB6LELS5TNUelxHZ/xzqA35Dg09gaDNgbA7sd1sSE0TWVJPSRNuaMfSRrWKYTpqGuQWEHGzop5N8nxiCWG1Uh/29/HLxlKJirBjrNG2iAMoZTDDqpU4Bd2OKBRqrGHVMtJIfSSUaiJ8fZmyb/JpVCvB1A4soh5FNMEatMOkGqmpMG5tyjT3+wUIsWYK9diasjp9CYKlJR0e8+fDrwU6VaxqVXYtr9FqIRaAohgYg6WmhKUgI6GgYTVMUz5NhmhE+ZD0CGpE8MXVmLZin/mlyifcBm3IJTlSVJGj1nJDUq9qlDSbnH/WVkq01Dhn8gcA\") format(\"woff2\"),url(iconfont.woff?t=1587278484908) format(\"woff\"),url(iconfont.ttf?t=1587278484908) format(\"truetype\"),url(iconfont.svg?t=1587278484908#iconfont) format(\"svg\")}.iconfont{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;font-family:iconfont!important;font-size:16px;font-style:normal}.icon-shanchu:before{content:\"\\e68a\"}.icon-icon-test:before{content:\"\\e61e\"}.icon-shanchu1:before{content:\"\\e614\"}";
styleInject(css_248z);

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  model: {
    prop: 'files',
    event: 'change'
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 0 // 0 预览模式 1 列表模式 2 预览模式 + 上传按钮

    },
    access: {
      type: String,
      default: 'image/*'
    },
    files: {
      type: Array,
      default: function _default() {
        return [];
      },
      // 图片
      required: true
    },
    label: {
      type: String,
      default: '点击上传' // 按钮文字

    },
    limit: {
      type: Number,
      default: 0 // 限制上传的图片数， 0 为不限制

    },
    maxSize: {
      type: Number,
      default: null // 图片最大尺寸，超过将不添加并触发 oversize 事件

    },
    multiple: {
      type: Boolean,
      default: false // 是否多选

    },
    compress: {
      type: Boolean,
      default: false // 是否开启压缩

    },
    quality: {
      type: Number,
      default: 0.8 // 默认压缩质量

    },
    beforeRead: {
      // 读取前钩子函数
      type: Function,
      default: null
    },
    afterRead: {
      // 读取后钩子函数
      type: Function,
      default: null
    },
    beforeRemove: {
      // 移除前钩子函数
      type: Function,
      default: null
    }
  },
  data: function data() {
    return {
      id: 'file' + Math.random().toString(16).slice(-13).replace(/\./g, '')
    };
  },
  methods: {
    remove: function remove(index) {
      if (this.disabled) return;
      if (this.beforeRemove && !this.beforeRemove(index, this.files[index])) return;
      var files = this.files.slice();
      files.splice(index, 1);
      this.$emit('change', files);
    },
    preview: function preview(index) {
      this.$emit('preview', index, this.files[index]);
    },
    fileChangeHandler: function fileChangeHandler(e) {
      var newFiles = e.target.files;

      if (this.beforeRead && !this.beforeRead(newFiles)) {
        this.$refs.vueUploadImg.value = '';
        return;
      }

      if (!this.verify(this.files.length + newFiles.length)) return;
      this.readFiles(newFiles);
    },
    readFiles: function readFiles(newFiles) {
      var _this = this;

      var canvas, ctx;

      if (this.compress) {
        canvas = document.createElement('canvas');
        ctx = canvas.getContext('2d');
      }

      var oldFiles = _toConsumableArray(this.files);

      var result = [];

      var _loop = function _loop(i, len) {
        var file = newFiles[i];

        if (file.type.includes('image')) {
          var reader = new FileReader();

          reader.onload = function (res) {
            var fileResult = res.target.result;

            if (!_this.compress) {
              _this.fileLoaded(file, fileResult, result, len, oldFiles);
            } else {
              var img = new Image();

              img.onload = function () {
                var w = img.width;
                var h = img.height;
                canvas.setAttribute('width', w);
                canvas.setAttribute('height', h);
                ctx.drawImage(img, 0, 0, w, h);
                var base64 = canvas.toDataURL(file.type, _this.quality);

                _this.fileLoaded(file, base64, result, len, oldFiles);
              };

              img.src = fileResult;
            }
          };

          reader.readAsDataURL(file);
        }
      };

      for (var i = 0, len = newFiles.length; i < len; i++) {
        _loop(i, len);
      }
    },
    fileLoaded: function fileLoaded(file, content, result, len, oldFiles) {
      if (this.maxSize !== null && this.isOverSize(file)) {
        this.$emit('oversize', file);
        return;
      }

      result.push({
        name: file.name,
        url: content,
        type: file.type,
        size: file.size
      });

      if (len == result.length) {
        this.$emit('change', oldFiles.concat(result));
        this.afterRead && this.afterRead(result);
        this.$refs.vueUploadImg.value = '';
      }
    },
    isOverSize: function isOverSize(file) {
      return file.size > this.maxSize;
    },
    verify: function verify(len) {
      if (/^\d+$/.test(this.limit) && this.limit !== 0) {
        if (this.limit < len) {
          this.$emit('exceed');
          return false;
        }
      }

      return true;
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}

var HEAD;
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);

      if (HEAD === undefined) {
        HEAD = document.head || document.getElementsByTagName('head')[0];
      }

      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "vue-upload-imgs",
    class: _vm.disabled ? 'vue-upload-disabled' : ''
  }, [_vm.type == 1 ? [_c('label', {
    staticClass: "upload-label-upload",
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "upload-main-list"
  }, _vm._l(_vm.files, function (item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item,
        expression: "item"
      }],
      key: index,
      staticClass: "upload-div-img-list"
    }, [_c('div', {
      staticClass: "upload-list-img-container"
    }, [_c('img', {
      attrs: {
        "src": item.url
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "upload-list-span"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "iconfont icon-shanchu",
      on: {
        "click": function click($event) {
          return _vm.remove(index);
        }
      }
    })]);
  }), 0)] : [_vm.type == 2 ? _c('label', {
    staticClass: "upload-label-upload",
    attrs: {
      "for": _vm.id
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('div', {
    staticClass: "upload-main"
  }, [_vm._l(_vm.files, function (item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item,
        expression: "item"
      }],
      key: index,
      staticClass: "upload-div-img"
    }, [_c('img', {
      attrs: {
        "src": item.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "upload-bg-img"
    }, [_c('span', {
      staticClass: "iconfont icon-icon-test",
      on: {
        "click": function click($event) {
          return _vm.preview(index);
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "iconfont icon-shanchu1",
      on: {
        "click": function click($event) {
          return _vm.remove(index);
        }
      }
    })])]);
  }), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !(_vm.limit !== 0 && _vm.limit == _vm.files.length),
      expression: "!(limit !== 0 && limit == files.length)"
    }],
    staticClass: "upload-div-add-img",
    attrs: {
      "for": _vm.id
    }
  }, [_c('span', {
    staticClass: "iconfont icon-icon-test"
  })])], 2)], _vm._v(" "), _c('input', {
    ref: "vueUploadImg",
    attrs: {
      "disabled": _vm.disabled,
      "type": "file",
      "id": _vm.id,
      "accept": _vm.access,
      "hidden": "",
      "multiple": _vm.multiple
    },
    on: {
      "change": _vm.fileChangeHandler
    }
  })], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = function __vue_inject_styles__(inject) {
  if (!inject) return;
  inject("data-v-2f4aea42_0", {
    source: ".vue-upload-imgs .upload-label-upload{border-radius:5px;font-size:16px;padding:6px 26px;background:#3594f2;color:#fff;font-weight:400;cursor:pointer;display:inline-block}.vue-upload-imgs .upload-main{font-size:0}.vue-upload-imgs .upload-div-add-img,.vue-upload-imgs .upload-div-img{min-width:148px;width:148px;height:148px;border-radius:6px;border:1px solid #c0ccda;overflow:hidden;position:relative;margin-right:6px;margin-top:5px;transition:opacity .3s;display:inline-block;font-size:14px}.vue-upload-imgs .upload-div-add-img{background-color:#fbfdff;border-style:dashed;cursor:pointer}.vue-upload-imgs .upload-div-add-img .iconfont{font-size:28px;color:#8c939d;font-weight:400;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);user-select:none}.vue-upload-imgs .upload-div-img img{width:100%;height:100%}.vue-upload-imgs .upload-div-img .iconfont{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);color:#fff;z-index:1;cursor:pointer;font-size:20px;user-select:none}.vue-upload-imgs .upload-div-img .icon-icon-test{left:40%}.vue-upload-imgs .upload-div-img .icon-shanchu1{left:60%}.vue-upload-imgs .upload-bg-img{position:absolute;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.5);display:none}.vue-upload-imgs .upload-div-img:hover{opacity:.8}.vue-upload-imgs .upload-div-img:hover .upload-bg-img{display:block}.vue-upload-imgs .upload-div-img-list{margin-top:10px;border:1px solid #c0ccda;padding:8px;box-sizing:border-box;width:212px;border-radius:5px}.vue-upload-imgs .upload-div-img-list .icon-shanchu{margin-left:10px;cursor:pointer;color:#8c939d}.vue-upload-imgs .upload-list-img-container{width:50px;overflow:hidden;border-radius:3px;border:1px solid #c0ccda}.vue-upload-imgs .upload-list-img-container img{width:100%;height:100%}.vue-upload-imgs .upload-list-img-container,.vue-upload-imgs .upload-list-span{display:inline-block;line-height:50px;height:50px;font-size:14px;vertical-align:top}.vue-upload-imgs .upload-list-span{width:100px;text-align:center;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.vue-upload-imgs .vue-upload-disabled .upload-label-upload{background-color:#f5f7fa;border-color:#e4e7ed;color:#c0c4cc;cursor:not-allowed}.vue-upload-imgs .vue-upload-disabled .upload-div-add-img{cursor:not-allowed}.vue-upload-imgs .vue-upload-disabled .icon-shanchu,.vue-upload-imgs .vue-upload-disabled .icon-shanchu1{cursor:not-allowed}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent_1({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, browser, undefined, undefined);

var install = function install(Vue) {
  Vue.component('VueUploadImgs', __vue_component__);
};

var API = {
  install: install
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export { __vue_component__ as VueUploadImgs, API as default };



//////////////////
// WEBPACK FOOTER
// ./~/vue-upload-imgs/dist/VueUploadImgs.esm.js
// module id = 144
// module chunks = 37